// Product ID to single Variant ID mapping
var tangent_selected_product_map;
let tangent_all_tags;

let skip_selfie=false;

const el = (sel, par) => (par||document).querySelector(sel);        
const elPopup = el("#tangent-popup-msg");      
const elPopupCondtion = el("#tangent-popup-msg-condition");

// Array of conditions detected on selfie with message to be shown onclick
var condition_msg_map =[];

// Consolidated final regions with products found
var final_selected_regions=[];

// Mapping possible tags from response to their possible regions
var area_mapping = {
  forehead:["rosacea_forehead","dark_spots_forehead","wrinkles_forehead","acne_forehead"],
  left_cheek:["rosacea_left_cheek","dark_spots_left_cheek","acne_left_cheek"],
  right_cheek:["rosacea_right_cheek","dark_spots_right_cheek","acne_right_cheek"],
  left_eye:["rosacea_left_eye","dark_spots_left_eye","acne_left_eye"],
  right_eye:["rosacea_right_eye","dark_spots_right_eye","acne_right_eye"],
  left_jaw:["dark_spots_left_jaw","acne_left_jaw"],
  right_jaw:["dark_spots_right_jaw","acne_right_jaw"],
  chin:["dark_spots_chin","acne_chin"],
  nose:["rosacea_nose","dark_spots_nose","acne_nose"],
  right_eye_under:["wrinkles_right_eye_under","dark_circles_right_eye_under"],
  right_eye_corner:["wrinkles_right_eye_corner"],
  left_eye_under:["wrinkles_left_eye_under","dark_circles_left_eye_under"],
  left_eye_corner:["wrinkles_left_eye_corner"],
  right_lip_corner:["wrinkles_right_lip_corner"],
  left_lip_corner:["wrinkles_left_lip_corner"]
};

var default_addToCartText = "Add To Cart";
var default_addedToCartText = "Added to Cart!";
var default_add_all_to_cart_text = "Add All to Cart"
var out_of_stock_text = "Out of Stock";
var no_products_found_text ="No products found. Please retry!";

// Map variable to store add all to cart links for each sections
var sections_add_to_cart_map={};

// Tab title mapping based on tags
var tabs_title_mapping={
  section_basics:"Basics",
  section_essentials:"Essentials",
  section_works:"Works"
}

const currentScriptUrl = document.currentScript.src;
const tangentAssetsBase = 'https://a.tangent.ai/DND/face-mapping/';

// Add default image url here
var tangent_default_selfie_image_url="https://file.tangent.ai/quiz-content/merchants/jane-gee/image/6359721026979381-skip_selfie.png";
var default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

var tangent_custom_tabs = document.querySelector("#tangent_custom_tabs");
var tangent_client_domain_url = window.location.origin;
var tangent_sections_wrapper_element = document.querySelector("#tangent_sections_wrapper"); 


window.onload = function() {
    var tangent_response_id = getClientResponseId()
    checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function checkoutDataProcess(response){
    var tangent_recommended_products = response.products;

    var tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    // Setting selfie / default image
    setTangentSelfieSection(response);
  
    var tangent_product_sections = response.product_sections;
    var tangent_text_sections = response.text_sections;
    
    if(tangent_product_sections!=undefined){
      createProductSection(tangent_product_sections, tangent_text_sections);
    }    
    tangent_all_tags = response.tags;
    setTabOpen(tangent_all_tags);
    if(response.text_sections!=undefined){
      createTextSection(tangent_product_sections,tangent_text_sections);
    }


    if(tangent_all_tags.length>0){
      // Selecting final marking regions from all tags
      for (var area in area_mapping) {
        var possible_tags = area_mapping[area];
        for(var pt=0;pt<possible_tags.length;pt++){
          if(tangent_all_tags.includes(possible_tags[pt])){
            final_selected_regions.push(possible_tags[pt]);
          }
        }
      }
      checkForProduct();
      if(condition_msg_map.length>0){
        selfie.init(tangentAssetsBase).then(() => {
          const u_list = getUniqueListBy(condition_msg_map, 'area');
          
          // Remove non marking locations from list
          var non_marking_list = ["left_eye","right_eye","left_jaw","right_jaw"];
          var i = 0;
          while (i < u_list.length) {
            if (non_marking_list.includes(u_list[i].area)) {
              u_list.splice(i, 1);
            } else {
              ++i;
            }
          }
          // MAX Count to 4
          if(u_list.length>4){
            u_list.length=4;
          }
          for(var cm=0;cm<u_list.length;cm++){
            selfie.markFacialArea(canvas, u_list[cm].area, u_list[cm].msg);
          }
           selfie.setAreaClickCallback(canvas, selfieAreaClicked, true);
           toggle_loader_view(false);
         
        }).catch((error) => {
          console.log("Error in loading model "+error);
          toggle_loader_view(false);
          show_selfie_popupmessage("Something went wrong, please check your internet connection!");
        });
      }
      else{

        if(!skip_selfie){
          var message = "Your selfie + skin is looking clear today! Here are the best products for your current skin-state. Feel like we missed something? Try taking your selfie again";
          show_selfie_popupmessage(message);
        }
        toggle_loader_view(false);
      }
      
    }
  
    if (tangent_recommended_products.length > 0) {
      
        tangent_selected_product_map = {};
        for (var p = 0; p < tangent_recommended_products.length; p++) {
          
          // By Default first variant is selected variant for the product
          var selected_variant = tangent_recommended_products[p].variants[0];
        
          tangent_selected_product_map[tangent_recommended_products[p].id] = tangent_recommended_products[p].variants[0].id;
          
          var product_html;

          if(tangent_product_sections!=undefined){
            for (const section in tangent_product_sections) {
              if (tangent_product_sections[section].includes(String(tangent_recommended_products[p].id))) {
                // Section product container / grid
                var product_section_grid = document.getElementById(section+"_product_grid");
                
                // Setting default / first variant data
                var product_price = selected_variant.price;
                var variant_image_url = getVariantImage(selected_variant.image_id,tangent_recommended_products[p]);
                var variant_product_url = tangent_client_domain_url + '/products/';
                variant_product_url = variant_product_url + tangent_recommended_products[p].handle + "?variant=" + selected_variant.id;

                // Product View HTML
                product_html = '<div><a id="url_tangent_product_' + p + '" class="tangent-text-link" target="_blank" href="' + variant_product_url + '"><img id="image_tangent_product_' + p + '" src="' + variant_image_url + '" class="tangent_product_image"><p class="tangent-product-title tangent_product_title_text"><b>' + tangent_recommended_products[p].title + '</b></p><p id="price_tangent_product_' + p + '" class="tangent_product_price_text">' + tangent_client_domain_currency + product_price + '</p></a><div id='+section+'_variant_'+p+'></div><a class="tangent-product-add-btn-wrapper" id="'+selected_variant.id+'" href="javascript: void(0)"><p class="tangent-btn-add tangent_add_to_cart_button" id="'+section+'_cart_tangent_product_' + p + '_text">' + default_addToCartText + '</p></a><div/>';
                
                product_section_grid.innerHTML = product_section_grid.innerHTML + product_html;

                // Enable / Disable add to cart buttons
                checkForProductValidity(tangent_product_sections,tangent_recommended_products,section,p, selected_variant);
                
              }                                
            }
          } 
        }
        enableButtonListener();
        loadElementsOnResponseData();        
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }

    if (response.description == '') {
        document.querySelector('#tangent-general-text').style.display = "block";
    }
}

function setTabOpen(tags){
  // Setting 1st tab active by default
  document.querySelector("#tab-wrapper").style.display="block";
  const tabContents = document.querySelectorAll(".tabcontent");
  const tabLinks = document.querySelectorAll(".tablinks");
  if(tags.includes("5_mins")){
    tabContents[0].style.display="block";
    tabLinks[0].classList.add("active");
  }
  else if(tags.includes("10_mins")){
    tabContents[1].style.display="block";
    tabLinks[1].classList.add("active");        
  }
  else{
    tabContents[2].style.display="block";
    tabLinks[2].classList.add("active");        
  }
}

// Product available / active
function checkForProductValidity(product_sections,product_list,section,idx,selected_variant){
  var cart_button = document.getElementById(section+'_cart_tangent_product_' + idx + '_text');
  if(cart_button!=undefined){
    // Check if Product is active
    if (product_list[idx].status == "active") {
          cart_button.classList.remove("disable-btn-wrapper");
          if(selected_variant.inventory_policy == "deny"){
              if(selected_variant.inventory_quantity<1){
                if(selected_variant.inventory_management!=null){
                  cart_button.innerHTML = out_of_stock_text;
                  cart_button.classList.add("disable-btn-wrapper");
                }
                else{
                    updateSectionAllToCartLink(product_sections,product_list[idx].id,tangent_selected_product_map[product_list[idx].id]);
                }
              }
              else{
                updateSectionAllToCartLink(product_sections,product_list[idx].id,tangent_selected_product_map[product_list[idx].id]);
              }
          }
          else{
            updateSectionAllToCartLink(product_sections,product_list[idx].id,tangent_selected_product_map[product_list[idx].id]);
        }
    }
    else {
        cart_button.innerHTML = out_of_stock_text;
        cart_button.classList.add("disable-btn-wrapper");
    }
  } 
}

// Updating add all to cart object for sections
function updateSectionAllToCartLink(product_sections,product_id,vid){
    if(product_sections!=undefined){
        for (const section in product_sections) {

            // Create and add all sections cart values to a map
            if (product_sections[section].includes(String(product_id))) {
                if(sections_add_to_cart_map[section]){
                    if(!sections_add_to_cart_map[section].list.includes(vid)){
                      sections_add_to_cart_map[section].count++;
                      sections_add_to_cart_map[section].cart_link =  sections_add_to_cart_map[section].cart_link+ "&id[]=" + vid;
                      sections_add_to_cart_map[section].list.push(vid);
                      
                      // Enable / disable add all to cart based on products count
                      if(sections_add_to_cart_map[section].count>1){
                          document.getElementById(section+"_add_all_to_cart").style.display="block";
                      }
                    }
                }
                else{
                    sections_add_to_cart_map[section] = {
                        count:1,
                        cart_link: tangent_client_domain_url + "/cart/add?id[]="+vid,
                        list:[vid]
                    }
                }
            }                                
        }
    }
}

// Add all to cart function for sections
function addAllTocartFunction(section) {  
    if(sections_add_to_cart_map[section]!=undefined){
        document.getElementById(section+"_add_all_cart_link").setAttribute("href", sections_add_to_cart_map[section].cart_link);
    } 
    else {
        var x = document.querySelector("#message-text");
        x.innerHTML = "We're currently sold out of the selected product(s). Please check back later!";
        x.className = "show";
        setTimeout(function () { x.className = x.className.replace("show", ""); }, 5000);
    }
}

const getVariantImage = (imageId, product) => {
    var product_image;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    product_image = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }

    if(product_image== undefined || product_image==null){
        product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
    }
    return product_image;
}

// Add To Cart Function
function addToCart(btn){ 
  let formData = {
   'items': [{
    'id': btn.id,
    'quantity': 1
    }]
  };
  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
     if(btn!=undefined){
        if(btn.childNodes[0]!=undefined){
          btn.childNodes[0].innerHTML = default_addedToCartText;
          btn.childNodes[0].classList.add("added-to-cart-style");
        }
        else{
          btn.innerHTML = default_addedToCartText;
          btn.classList.add("added-to-cart-style"); 
        }
      }    
      document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
      document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true
      })); 
      return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

// Toggle - selfie canvas 
function selfieCanvasDisplayToggle(display){
  document.querySelector("#selfie_canvas").style.display=display;  
}

// Main Section container 
function createSectionContainer(section_name){
    var section_container = document.createElement("div");
    section_container.id=section_name+"_container";
    if(section_name!="section_upsell" && section_name!="section_selfie"){
      section_container.classList.add("tabcontent");
    }
    return section_container;
}

// Add to cart button for sections
function createSectionAddAllToCart(section_name) {
    var add_all_to_cart_p_tag = document.createElement("p");
    add_all_to_cart_p_tag.id = section_name+"_add_all_to_cart";
    add_all_to_cart_p_tag.classList.add("section_add_all_to_cart");
    add_all_to_cart_p_tag.classList.add(section_name+"_add_all_to_cart");

    var add_all_cart_link = document.createElement("a");
    add_all_cart_link.id = section_name+"_add_all_cart_link";
    add_all_cart_link.classList.add("section_add_all_cart_link");
    add_all_cart_link.classList.add(section_name+"_add_all_cart_link");
    add_all_cart_link.href="#";
    add_all_cart_link.innerHTML = default_add_all_to_cart_text;

    // Enabling listener
    add_all_cart_link.addEventListener(
        'click',
        function () { addAllTocartFunction(section_name); },
        false
    );
    add_all_to_cart_p_tag.appendChild(add_all_cart_link);
    return add_all_to_cart_p_tag;
}

// Container having individual products
function addSectionProductGridContainer(section_name) {
    var product_grid_view_container = document.createElement("div");
    product_grid_view_container.id = section_name+"_product_grid";
    product_grid_view_container.classList.add("section_product_grid");
    product_grid_view_container.classList.add(section_name+"_product_grid");
    return product_grid_view_container;
}

// Tab buttons 
function createTabButton(section_name) {
    var tab_button = document.createElement("button");
    tab_button.id = section_name+"_tab_button";
    tab_button.innerHTML = getTabTitle(section_name);
    tab_button.name = section_name;
    tab_button.classList.add("tablinks");
    tab_button.addEventListener(
        'click',
        function () { switchTab(this); },
        false
    );
    tangent_custom_tabs.appendChild(tab_button);
}

function getTabTitle(section){
  var tab_title;
  if(tabs_title_mapping[section]!=undefined){
    tab_title = tabs_title_mapping[section];
  }
  else{
    tab_title = section.replace("section_","").replace("_"," ").toUpperCase();
  }
  return tab_title;
}

// Product Section Creation
function createProductSection(product_sections, text_sections){
    for (const section_name in product_sections) {
      // The created container will have both a container to show text and products
      var section_container = createSectionContainer(section_name);    
  
      // Creating text sections before products sections if exists
      if(text_sections!=undefined){
          createTextSectionBeforeProducts(text_sections,section_container,section_name);
      }    
      
      // Creating section to add all products
      section_container.appendChild(addSectionProductGridContainer(section_name));
  
      // Creating add all to cart button for the section    
      section_container.appendChild(createSectionAddAllToCart(section_name));

      // Add to main container wrapper
      
      if(section_name!="section_upsell"){
        createTabButton(section_name);
        tangent_sections_wrapper_element.appendChild(section_container);
      }
      else{
          var section_upsell_container = document.querySelector("#section_upsell_container_parent");
          section_upsell_container.appendChild(section_container); 
      }
      
    }
}

// Text Sections with products sections
function createTextSectionBeforeProducts(text_sections,section_container, section_name){
    if(text_sections[section_name]!=undefined){
        var section_div = document.createElement("div");
        section_div.id = section_name+"_text_container";
        section_div.classList.add("section_text_container");
        section_div.classList.add(section_name+"_text_container");
        section_div.innerHTML = text_sections[section_name].join(' ');
        section_container.appendChild(section_div);
    }
}

// Section Text Creation (one without a product section)
function createTextSection(product_sections, text_sections){
    for (const section_name in text_sections) {
        // For removing duplicate entry
        if(product_sections[section_name]==undefined){
            var section_container = createSectionContainer(section_name);

            var section_div = document.createElement("div");
            section_div.id = section_name+"_text_container";
            section_div.classList.add("section_text_container");
            section_div.classList.add(section_name+"_text_container");
            section_div.innerHTML = text_sections[section_name].join(' ');
            section_container.appendChild(section_div);  

            // To Add to top of the page container
            if(section_name == "section_selfie"){
              var section_selfie = document.querySelector("#section_selfie_container_parent");
              section_selfie.appendChild(section_container);
            }
            else if(section_name=="section_upsell"){
              var section_upsell_container = document.querySelector("#section_upsell_container");
              section_upsell_container.appendChild(section_container); 
            } 
            else{
              // Add to main container wrapper
              tangent_sections_wrapper_element.appendChild(section_container); 
            }   
        }
    }
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
  hideLoading();
  // Default image hiding
  document.getElementById('selfie_img_cover').style.display = "none";
  document.getElementById('tangent_selfie_div').style.display = "flex";
  document.getElementById('selfie_img').src = response.selfie_url;
  if(response.selfie_html!=null && response.selfie_html!=undefined){
    // document.getElementById("tangent_selfie_div").innerHTML = jsonData.selfie_html;
  }
  else{
    var selfie_img = document.getElementById("selfie_img");
    
    if(response.selfie_url!=undefined && response.selfie_url!=null){
      selfie_img.src = response.selfie_url;
    }
    else{
      skip_selfie= true;
      selfie_img.src=tangent_default_selfie_image_url;
    }
  }
    // if(response.selfie_html!=null && response.selfie_html!=undefined){
    //   document.getElementById("tangent_selfie_container").innerHTML = response.selfie_html;
    // }
    // else{
    //     if(response.selfie_url!=undefined && response.selfie_url!=null){
    //       document.querySelector('#tangent_selfie_image').src = response.selfie_url;
    //     }
    //     else{
    //         if(tangent_default_selfie_image_url!=""){
    //             document.querySelector('#tangent_selfie_image').src = tangent_default_selfie_image_url;
    //         }
    //         else{
    //             document.querySelector("#tangent_selfie_container").style.display = "none";
    //         }
    //     }
    // }
}

// Handle Tab button selection
function switchTab(element) {
  let i, tabcontent, tablinks;

  // This is to clear the previous clicked content.
  tabcontent = document.querySelectorAll(".tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  
  tablinks = document.querySelectorAll(".tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // Display the clicked tab and set it to active.
  document.getElementById(element.name+"_container").style.display = "block";
  document.getElementById(element.name+"_tab_button").classList.add("active");
}

// Enabling button listeners
function enableButtonListener(){
    // Listner for section add all to carts
    var all_btns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    for (var b = 0; b < all_btns.length; b++) {
        all_btns[b].addEventListener(
            'click',
            function () { addToCart(this); },
            false
        );
    }
}

function loadElementsOnResponseData(){
  var all_elements = document.querySelectorAll('.load-on-data');
  for (var ae = 0; ae < all_elements.length; ae++) {
      all_elements[ae].style.display="block";
  }
}

// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}


// Show / Hide loader
function toggle_loader_view(status){
  if(status){
    document.getElementById("tangent-selfie-loader").setAttribute("style","display:flex;text-align:center;padding:0px 10px;width:300px;margin:4%");
  }
  else{
    document.getElementById("tangent-selfie-loader").setAttribute("style","display:none");
  }
}

function changeLoadingText(txt){
    document.getElementById("loading_text").innerHTML = txt;
}

// Default message Popup
function show_selfie_popupmessage(message){
  document.getElementById("tangent-popup-msg").innerHTML = message;
  const element = el("#tangent_selfie_div");
  var rect = element.getBoundingClientRect();
  document.getElementById("tangent-popup-msg").setAttribute("style","top:10px;left:"+element.offsetLeft+";display:block;max-width: 400px; border:1px solid #cccccc");
}

function getUniqueListBy(arr, key) {
    return [...new Map(arr.map(item => [item[key], item])).values()]
}

// Check for product from product list and make popup message on image
function checkForProduct(){
  var add_to_list = 0;
  for(var fr=0;fr<final_selected_regions.length;fr++){
    var c_area;
    var html_msg;
    if(final_selected_regions[fr].includes("acne")){
      c_area = final_selected_regions[fr].replace('acne_','');
      html_msg= '<p>Prone to acne here? Try our <a href="/products/janegee-clear-skin?variant=31218739150914" target="_blank"><u>Clear Skin</u></a> & <a href="/products/janegee-face-oil-no-4?variant=31218653462594" target="_blank"><u> Face Oil No. 4</u></a>.</p>';
    } 
    else if(final_selected_regions[fr].includes("wrinkles")){
      c_area = final_selected_regions[fr].replace('wrinkles_','');
      html_msg= '<p>Prone to wrinkles here? Try our <a href="/products/janegee-elixir-corrective-serum?variant=31218739773506" target="_blank"><u>Elixir Corrective Serum</a></u> & <a href="/products/janegee-face-oil-no-1?variant=31218645827650" target="_blank"><u>No. 1 Face Oil</u></a>.</p>';  
    } 
    else if(final_selected_regions[fr].includes("rosacea")){
      c_area = final_selected_regions[fr].replace('rosacea_','');
      html_msg= '<p>Prone to rosacea here? Try our <a href="/products/janegee-cleanser-no-3?variant=31218738987074" target="_blank"><u>Cleanser No. 3</u></a> & <a href="/products/janegee-beauty-oil?variant=41793852375106" target="_blank"><u>Beauty Oil</u></a>.</p>';
    } 
    else if(final_selected_regions[fr].includes("dark_spots")){
      c_area = final_selected_regions[fr].replace('dark_spots_','');
      html_msg= '<p>Prone to dark-spots here? Try our <a href="/products/janegee-elixir-corrective-serum?variant=31218739773506" target="_blank"><u>Elixir Corrective Serum</a> & <a href="/products/janegee-face-oil-no-2?variant=31218647662658" target="_blank">No. 2 Face Oil</u></a>.</p>';    
    }
    else if(final_selected_regions[fr].includes("dark_circles")){
      c_area = final_selected_regions[fr].replace('dark_circles_','');
      html_msg= '<p>You have dark circles here. Try our <a href="/products/janegee-eye-oil?variant=31218739806274" target="_blank"><u>Eye Oil</u></a> & <a href="/products/janegee-elixir-corrective-serum?variant=31218739773506" target="_blank"><u>Elixir Corrective Serum</u></a></p>';
    } 
    else{
      
    }
    if(add_to_list<5){
       var cm_map = {
        area:c_area,
        msg: html_msg
      };
      add_to_list = add_to_list+1;
      condition_msg_map.push(cm_map);
    }
  }  
}


class TangentSelfie {
	areasToMarkArray = []

    FILL_COLOR = 'rgba(255, 255, 255, 0.2)'
	STROKE_COLOR = 'rgba(255, 255, 255, 0.6)'
	STROKE_HIGHLIGHT_COLOR = 'rgba(255, 255, 255, 1)'
	
	UNDER_EYE_BAGS_HEIGHT = 15
	CHIN_AREA_HEIGHT = 20
	MOUTH_WRINKLES_WIDTH = 10

	EYE_WRINKLE_MIN_WIDTH = 10
	EYE_WRINKLE_MAX_WIDTH = 15
	CHEEK_WIDTH_CUTOFF = 30
	UNDER_EYE_BAGS_WIDTH_CUTTOFF = 20

    CHEEK_MAX_WIDTH = 35
    CHEEK_MAX_HEIGHT = 35
  
    FOREHEAD_MAX_WIDTH = 55
    FOREHEAD_MAX_HEIGHT = 30

	constructor(imgId){
		this.img = document.getElementById(imgId);
	}

	async init(assetsBaseUrl) {
      try{
        // Handle the case if the image is not loaded yet
        await this.imageLoad(this.img);
        await this.sleep(2000); // To allow canvas to resize
        const options = new faceapi.SsdMobilenetv1Options({ minConfidence: 0.2 })
        await faceapi.loadSsdMobilenetv1Model(assetsBaseUrl);
        await faceapi.loadFaceLandmarkModel(assetsBaseUrl);

        this.faceLandmarks = await faceapi.detectSingleFace(this.img, options).withFaceLandmarks();
        this.detection = this.faceLandmarks.detection;

      } catch(e){
        console.log(e);
      }

      if(!this.detection){
        throw new Error("Detection was not found");
      }
	}

	async imageLoad(imgElem) {
	    return new Promise(res => {
	        if (imgElem.complete) {
	            return res();
	        }
	        imgElem.onload = () => res();
	        imgElem.onerror = () => res();
	    });
	}

	async sleep(ms) {
	    return new Promise(resolve => setTimeout(resolve, ms));
	}

	get imgWidth(){
		return this.detection.imageWidth
	}

	get imgHeight(){
		return this.detection.imageHeight
	}

	/* ------------------ Facial feature mathematical functions ---------------------- */

	getAngleToFaceRightInRadians(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()

		const theta = this.getAngleWithXAxisInRadians(leftEyePoints[0], rightEyePoints[0])
		if(theta < Math.PI/2){
			return theta // Face tilted to clockwise
		} else {
			return theta - Math.PI // Face tilted to anti-clockwise
		}
	}

	getAngleToFaceLeftInRadians(){
		return this.getAngleToFaceRightInRadians() - Math.PI
	}

	getAngleToFaceDownInRadians(){
		let horzontalAngle = this.getAngleToFaceRightInRadians()
		return horzontalAngle + Math.PI/2
	}

	getAngleToFaceUpInRadians(){
		return this.getAngleToFaceDownInRadians() - Math.PI
	}

	getLeftEyeHeight(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		const h1 = this.getDistanceBetweenPoints(leftEyePoints[1], leftEyePoints[5])
		const h2 = this.getDistanceBetweenPoints(leftEyePoints[2], leftEyePoints[4])
		return Math.max(h1, h2)
	}

	getLeftEyeWidth(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		return this.getDistanceBetweenPoints(leftEyePoints[0], leftEyePoints[3])
	}

	getRightEyeHeight(){
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		const h1 = this.getDistanceBetweenPoints(rightEyePoints[1], rightEyePoints[5])
		const h2 = this.getDistanceBetweenPoints(rightEyePoints[2], rightEyePoints[4])
		return Math.max(h1, h2)
	}

	getLeftCrowFeetHeight(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow()
		return this.getDistanceBetweenPoints(leftEyePoints[0], leftEyeBrowPoints[1])
	}

	getRightCrowFeetHeight(){
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		let rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow()
		return this.getDistanceBetweenPoints(rightEyePoints[3], rightEyeBrowPoints[3])
	}

	getRightEyeWidth(){
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		return this.getDistanceBetweenPoints(rightEyePoints[0], rightEyePoints[3])
	}

	getLeftCrowFeetWidth(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline()
		return Math.min(this.EYE_WRINKLE_MAX_WIDTH, this.getDistanceBetweenPoints(leftEyePoints[0], jawOutlinePoints[0]))
	}

	getRightCrowFeetWidth(){
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline()
		return Math.min(this.EYE_WRINKLE_MAX_WIDTH, this.getDistanceBetweenPoints(rightEyePoints[3], jawOutlinePoints[16]))
	}

	getNoseWidth(){
		let nosePoints = this.faceLandmarks.landmarks.getNose()
		return this.getDistanceBetweenPoints(nosePoints[4], nosePoints[8])
	}

	getNoseHeight(){
		let nosePoints = this.faceLandmarks.landmarks.getNose()
		return this.getDistanceBetweenPoints(nosePoints[0], nosePoints[6])
	}

	getMouthWidth(){
		let mouthPoints = this.faceLandmarks.landmarks.getMouth()
		return this.getDistanceBetweenPoints(mouthPoints[0], mouthPoints[6])
	}

	getMouthHeight(){
		let mouthPoints = this.faceLandmarks.landmarks.getMouth()
		return this.getDistanceBetweenPoints(mouthPoints[3], mouthPoints[9])
	}

	getForeheadWidth(){
		let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow()
		let rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow()
		return this.getDistanceBetweenPoints(leftEyeBrowPoints[2], rightEyeBrowPoints[2])
	}

	getForeheadHeight(){
		let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow()
		let rightEyeBrowPoints = this.faceLandmarks.landmarks.getRightEyeBrow()

		let faceTopPt = this.getToptMostPt(this.getFaceBounds())

		const h1 = leftEyeBrowPoints[2]._y - faceTopPt._y
		const h2 = rightEyeBrowPoints[2]._y - faceTopPt._y 

		return Math.min(h1, h2)
	}

	getLeftCheekWidth(){
		let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline()
		let nosePoints = this.faceLandmarks.landmarks.getNose()
		return this.getDistanceBetweenPoints(jawOutlinePoints[3], nosePoints[4])
	}

	getRightCheekWidth(){
		let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline()
		let nosePoints = this.faceLandmarks.landmarks.getNose()
		return this.getDistanceBetweenPoints(jawOutlinePoints[13], nosePoints[8])
	}

	getCheekHeight(){
		return this.getNoseHeight() - this.UNDER_EYE_BAGS_HEIGHT
	}

	getChinWidth(){
		let jawOutlinePoints = this.faceLandmarks.landmarks.getJawOutline()
		return this.getDistanceBetweenPoints(jawOutlinePoints[7], jawOutlinePoints[9])
	}

	getChinHeight(){
		return this.CHIN_AREA_HEIGHT
	}

	getFaceBounds(){
		const leftX = this.detection._box._x
		const rightX = this.detection._box._x + this.detection._box._width
		const topY = this.detection._box._y
		const bottomY = this.detection._box._y + this.detection._box._height
		return [{_x: leftX, _y: topY}, {_x: rightX, _y: bottomY}]
	}

	getForeheadBounds() {
    let foreheadWidth = this.getForeheadWidth()
    let foreheadLeftRightPadding = 0
    if(foreheadWidth > this.FOREHEAD_MAX_WIDTH){
      foreheadLeftRightPadding = (foreheadWidth - this.FOREHEAD_MAX_WIDTH)/2
      foreheadWidth = this.FOREHEAD_MAX_WIDTH
    }

    let foreheadHeight = this.getForeheadHeight()
    let foreheadTopBottomPadding = 0
    if(foreheadHeight > this.FOREHEAD_MAX_HEIGHT){
      foreheadTopBottomPadding = (foreheadHeight - this.FOREHEAD_MAX_HEIGHT)/2
      foreheadHeight = this.FOREHEAD_MAX_HEIGHT
    }

    let leftEyeBrowPoints = this.faceLandmarks.landmarks.getLeftEyeBrow()


    const leftBrowPt = leftEyeBrowPoints[2]
    const leftPaddingPt = this.getPointAtDistanceAndAngle(leftBrowPt, foreheadLeftRightPadding, this.getAngleToFaceRightInRadians())

    const leftBottomPt = this.getPointAtDistanceAndAngle(leftPaddingPt, foreheadTopBottomPadding, this.getAngleToFaceUpInRadians())

    const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, foreheadWidth, this.getAngleToFaceRightInRadians())
    const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, foreheadHeight, this.getAngleToFaceUpInRadians())
    const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, foreheadHeight, this.getAngleToFaceUpInRadians())

    return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
  }

	getLeftUnderEyeBounds() {
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		
		const leftTopPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftEyeHeight()/2, this.getAngleToFaceDownInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getLeftEyeWidth(), this.getAngleToFaceRightInRadians())
		const leftBottomPt = this.getPointAtDistanceAndAngle(leftTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians())
		const rightBottomPt = this.getPointAtDistanceAndAngle(rightTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians())

		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getRightUnderEyeBounds() {
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		
		const leftTopPt = this.getPointAtDistanceAndAngle(rightEyePoints[0], this.getRightEyeHeight()/2, this.getAngleToFaceDownInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getRightEyeWidth(), this.getAngleToFaceRightInRadians())
		const leftBottomPt = this.getPointAtDistanceAndAngle(leftTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians())
		const rightBottomPt = this.getPointAtDistanceAndAngle(rightTopPt, this.UNDER_EYE_BAGS_HEIGHT, this.getAngleToFaceDownInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getLeftCrowFeetBounds(){
		let leftEyePoints = this.faceLandmarks.landmarks.getLeftEye()
		
		const rightBottomPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftCrowFeetHeight()/2, this.getAngleToFaceDownInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(leftEyePoints[0], this.getLeftCrowFeetHeight()/2, this.getAngleToFaceUpInRadians())
		const leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getLeftCrowFeetWidth(), this.getAngleToFaceLeftInRadians())
		const leftTopPt = this.getPointAtDistanceAndAngle(rightTopPt, this.getLeftCrowFeetWidth(), this.getAngleToFaceLeftInRadians())

		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getRightCrowFeetBounds(){
		let rightEyePoints = this.faceLandmarks.landmarks.getRightEye()
		
		const leftTopPt = this.getPointAtDistanceAndAngle(rightEyePoints[3], this.getRightCrowFeetHeight()/2, this.getAngleToFaceUpInRadians())
		const leftBottomPt = this.getPointAtDistanceAndAngle(rightEyePoints[3], this.getRightCrowFeetHeight()/2, this.getAngleToFaceDownInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(leftTopPt, this.getRightCrowFeetWidth(), this.getAngleToFaceRightInRadians())
		const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getRightCrowFeetWidth(), this.getAngleToFaceRightInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getNoseBounds(){
		let nosePoints = this.faceLandmarks.landmarks.getNose()
		
		const leftBottomPt = nosePoints[4]
		const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getNoseWidth(), this.getAngleToFaceRightInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getNoseHeight(), this.getAngleToFaceUpInRadians())
		const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getNoseHeight(), this.getAngleToFaceUpInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getLeftCheekBounds(){
    let cheekWidth = this.getLeftCheekWidth()
    let cheekLeftRightPadding = 0
    if(cheekWidth > this.CHEEK_MAX_WIDTH){
      cheekLeftRightPadding = (cheekWidth - this.CHEEK_MAX_WIDTH)/2
      cheekWidth = this.CHEEK_MAX_WIDTH
    }

    let cheekHeight = this.getCheekHeight()
    let cheekTopBottomPadding = 0
    if(cheekHeight > this.CHEEK_MAX_HEIGHT){
      cheekTopBottomPadding = (cheekHeight - this.CHEEK_MAX_HEIGHT)/2
      cheekHeight = this.CHEEK_MAX_HEIGHT
    }

    const leftJawPt = this.faceLandmarks.landmarks.getJawOutline()[3] 
    const leftPaddingPt = this.getPointAtDistanceAndAngle(leftJawPt, cheekLeftRightPadding, this.getAngleToFaceRightInRadians())

    const leftBottomPt = this.getPointAtDistanceAndAngle(leftPaddingPt, cheekTopBottomPadding, this.getAngleToFaceUpInRadians())

    const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekWidth, this.getAngleToFaceRightInRadians())
    const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekHeight, this.getAngleToFaceUpInRadians())
    const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekHeight, this.getAngleToFaceUpInRadians())
    
    return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
  }

  getRightCheekBounds(){
    let cheekWidth = this.getRightCheekWidth()
    let cheekLeftRightPadding = 0
    if(cheekWidth > this.CHEEK_MAX_WIDTH){
      cheekLeftRightPadding = (cheekWidth - this.CHEEK_MAX_WIDTH)/2
      cheekWidth = this.CHEEK_MAX_WIDTH
    }

    let cheekHeight = this.getCheekHeight()
    let cheekTopBottomPadding = 0
    if(cheekHeight > this.CHEEK_MAX_HEIGHT){
      cheekTopBottomPadding = (cheekHeight - this.CHEEK_MAX_HEIGHT)/2
      cheekHeight = this.CHEEK_MAX_HEIGHT
    }

    const rightJawPt = this.faceLandmarks.landmarks.getJawOutline()[13] 
    const rightPaddingPt = this.getPointAtDistanceAndAngle(rightJawPt, cheekLeftRightPadding, this.getAngleToFaceLeftInRadians())

    const rightBottomPt = this.getPointAtDistanceAndAngle(rightPaddingPt, cheekTopBottomPadding, this.getAngleToFaceUpInRadians())

    const leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekWidth, this.getAngleToFaceLeftInRadians())
    const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, cheekHeight, this.getAngleToFaceUpInRadians())
    const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, cheekHeight, this.getAngleToFaceUpInRadians())
    
    return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
  }

	getChinBounds(){
		const leftBottomPt = this.faceLandmarks.landmarks.getJawOutline()[7] 

		const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getChinWidth(), this.getAngleToFaceRightInRadians())
		const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getChinHeight(), this.getAngleToFaceUpInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getChinHeight(), this.getAngleToFaceUpInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getLeftMouthWrinkleBounds(){
		let mouthPoints = this.faceLandmarks.landmarks.getMouth()
		
		const rightBottomPt = this.getPointAtDistanceAndAngle(mouthPoints[0], this.getMouthHeight()/2, this.getAngleToFaceDownInRadians())
		const leftBottomPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.MOUTH_WRINKLES_WIDTH, this.getAngleToFaceLeftInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians())
		const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	getRightMouthWrinkleBounds(){
		let mouthPoints = this.faceLandmarks.landmarks.getMouth()
		
		const leftBottomPt = this.getPointAtDistanceAndAngle(mouthPoints[6], this.getMouthHeight()/2, this.getAngleToFaceDownInRadians())
		const rightBottomPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.MOUTH_WRINKLES_WIDTH, this.getAngleToFaceRightInRadians())
		const rightTopPt = this.getPointAtDistanceAndAngle(rightBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians())
		const leftTopPt = this.getPointAtDistanceAndAngle(leftBottomPt, this.getMouthHeight(), this.getAngleToFaceUpInRadians())
		
		return [leftTopPt, leftBottomPt, rightBottomPt, rightTopPt]
	}

	/* ------------------ Utility methods ---------------------- */

	getDistanceBetweenPoints(p1, p2) {
		return Math.sqrt(Math.pow(p1._x - p2._x, 2) + Math.pow(p1._y - p2._y, 2))
	}

	getMidpointBetweenPoints(p1, p2) {
		return {_x: Math.abs((p1._x + p2._x)/2), _y: Math.abs((p1._y + p2._y)/2)}
	}

	getAngleWithXAxisInRadians(p1, p2) {
		let dy = p1._y - p2._y;
		let dx = p1._x - p2._x;
		let theta = Math.atan2(dy, dx); // range (-PI, PI]
		if (theta < 0) {
			theta += Math.PI
		} 
		return theta;
	}

	getPointAtDistanceAndAngle(sourcePt, distance, angle) {
		return {_x: sourcePt._x + distance*Math.cos(angle), _y:sourcePt._y + distance*Math.sin(angle)}
	}

	getLeftMostPt(pointsArray) {
		let leftMost = null
		for (let i = 0; i < pointsArray.length; i++) {
			if(leftMost == null || pointsArray[i]._x < leftMost._x){
				leftMost = pointsArray[i];
			}			  
		}
		return leftMost;
	}

	getRightMostPt(pointsArray) {
		let rightMost = null
		for (let i = 0; i < pointsArray.length; i++) {
			if(rightMost == null || pointsArray[i]._x > rightMost._x){
				rightMost = pointsArray[i];
			}			  
		}
		return rightMost;
	}

	getToptMostPt(pointsArray) {
		let topMost = null
		for (let i = 0; i < pointsArray.length; i++) {
			if(topMost == null || pointsArray[i]._y < topMost._y){
				topMost = pointsArray[i];
			}			  
		}
		return topMost;
	}

	isPointInsidePoligon(pt, points) {
	    // https://stackoverflow.com/a/29915728/960654
	    // ray-casting algorithm based on
	    // https://wrf.ecse.rpi.edu/Research/Short_Notes/pnpoly.html/pnpoly.html
	    
	    var x = pt._x, y = pt._y;
	    
	    var inside = false;
	    for (var i = 0, j = points.length - 1; i < points.length; j = i++) {
	        var xi = points[i]._x, yi = points[i]._y;
	        var xj = points[j]._x, yj = points[j]._y;
	        
	        var intersect = ((yi > y) != (yj > y))
	            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
	        if (intersect) inside = !inside;
	    }
	    
	    return inside;
	}

	/* ------------------ Canvas methods ---------------------- */

	clearCanvas(canvas){
		const ctx = canvas.getContext('2d');
		ctx.resetTransform();
		ctx.clearRect(0, 0, canvas.width, canvas.height);
	}

	scaleCanvas(canvas){
		var ctx = canvas.getContext("2d");
		ctx.resetTransform();
		ctx.scale(canvas.width/this.imgWidth, canvas.height/this.imgHeight);
  }

  scaleUpPt(originalPt, canvas){
    const canvasWidth = canvas.getBoundingClientRect().width;
    const canvasHeight = canvas.getBoundingClientRect().height;
    return {_x: (canvasWidth * originalPt._x)/this.imgWidth, _y: (canvasHeight * originalPt._y)/this.imgHeight}
  }

	scaleBackPt(scaledPt, canvas){
		const canvasWidth = canvas.getBoundingClientRect().width;
		const canvasHeight = canvas.getBoundingClientRect().height;
		return {_x: (this.imgWidth * scaledPt._x)/canvasWidth, _y: (this.imgHeight * scaledPt._y)/canvasHeight}
	}

	applyCanvasStrokeColor(canvas, color){
		var ctx = canvas.getContext("2d");
		ctx.strokeStyle = color
	}

	setStrokeColor(color){
		this.STROKE_COLOR = color
	}

	setHighlightStrokeColor(color){
		this.STROKE_HIGHLIGHT_COLOR = color
	}

	setAreaClickCallback(canvas, callback, setFirstAutoClick=false){
		this.areaClickCallback = callback

    if(setFirstAutoClick && this.areasToMarkArray.length > 0) {
      this.areasToMarkArray[0].clicked = true
      this.drawAllShapes(canvas)

      const scaledPt = this.scaleUpPt(this.areasToMarkArray[0].points[0], canvas)
      this.areaClickCallback(this.areasToMarkArray[0].area, this.areasToMarkArray[0].messageOnClick, scaledPt._x, scaledPt._y)
    }
	}

	appendAreaToArray(area, points, messageOnClick){
		this.areasToMarkArray.push({
			area: area,
			points: points,
			messageOnClick: messageOnClick
		})
	}

	markFacialArea(canvas, area, messageOnClick){
		let points = null;
		switch(area) {
			case 'forehead':
				points = this.getForeheadBounds()
				break;
			case 'left_eye_under':
				points = this.getLeftUnderEyeBounds()
				break;
			case 'right_eye_under':
				points = this.getRightUnderEyeBounds()
				break;
			case 'left_eye_corner':
				points = this.getLeftCrowFeetBounds()
				break;
			case 'right_eye_corner':
				points = this.getRightCrowFeetBounds()
				break;
			case 'nose':
				points = this.getNoseBounds()
				break;
			case 'left_cheek':
				points = this.getLeftCheekBounds()
				break;
			case 'right_cheek':
				points = this.getRightCheekBounds()
				break;
			case 'left_lip_corner':
				points = this.getLeftMouthWrinkleBounds()
				break;
			case 'right_lip_corner':
				points = this.getRightMouthWrinkleBounds()
				break;
			case 'chin':
				points = this.getChinBounds()
				break;
		}

		if(points != null){
			this.appendAreaToArray(area, points, messageOnClick)
			this.drawAllShapes(canvas)
		}
	}

	drawAllShapes(canvas){
		this.clearCanvas(canvas)
		this.applyCanvasStrokeColor(canvas, this.STROKE_COLOR)
		for (let i = 0; i < this.areasToMarkArray.length; i++) {
			this.drawSingleShape(canvas, this.areasToMarkArray[i].area, this.areasToMarkArray[i].points, 'clicked' in this.areasToMarkArray[i])
		}

		if(this.clickListener){
			canvas.removeEventListener("click", this.clickListener, true);
		}
		this.clickListener = this.canvasClickListener.bind(this)
		canvas.addEventListener("click", this.clickListener, true);
	}

	drawSingleShape(canvas, area, points, clicked){
    switch(area) {
      case 'forehead':
        this.drawForehead(canvas, area, points, clicked)
        break;
      case 'left_eye_under':
        this.drawUnderEyeBags(canvas, area, points, clicked)
        break;
      case 'right_eye_under':
        this.drawUnderEyeBags(canvas, area, points, clicked)
        break;
      case 'left_eye_corner':
        this.drawEyeWrinkles(canvas, area, points, clicked)
        break;
      case 'right_eye_corner':
        this.drawEyeWrinkles(canvas, area, points, clicked)
        break;
      case 'nose':
        this.drawNose(canvas, area, points, clicked)
        break;
      case 'left_cheek':
        this.drawCheeks(canvas, area, points, clicked)
        break;
      case 'right_cheek':
        this.drawCheeks(canvas, area, points, clicked)
        break;
      case 'left_lip_corner':
        this.drawMouthWrinkles(canvas, area, points, clicked)
        break;
      case 'right_lip_corner':
        this.drawMouthWrinkles(canvas, area, points, clicked)
        break;
      case 'chin':
        this.drawChin(canvas, area, points, clicked)
        break;
    }
  }

	getCursorPosition(canvas, event) {
	    const rect = canvas.getBoundingClientRect()
	    const x = event.clientX - rect.left
	    const y = event.clientY - rect.top
	    return {_x: x, _y: y}
	}

	canvasClickListener(event){
    let canvas = event.target || event.srcElement;
    const clickPt = this.getCursorPosition(canvas, event)

    let shapeClickedIndex = -1

    for (let i = 0; i < this.areasToMarkArray.length; i++) {
      if(shapeClickedIndex == -1 && this.isPointInsidePoligon(this.scaleBackPt(clickPt, canvas), this.areasToMarkArray[i].points)){
        shapeClickedIndex = i
        this.areasToMarkArray[i].clicked = true
      } else if('clicked' in this.areasToMarkArray[i]){
        delete this.areasToMarkArray[i].clicked
      }
    }

    this.drawAllShapes(canvas) 

    if(this.areaClickCallback){
      // Call the callback function if it is outside any shape with null area value
      if(shapeClickedIndex == -1){
        this.areaClickCallback(null, null, clickPt._x, clickPt._y)
      } else {
        this.areaClickCallback(this.areasToMarkArray[shapeClickedIndex].area, this.areasToMarkArray[shapeClickedIndex].messageOnClick, clickPt._x, clickPt._y)
      }
    }
  }

  drawForehead(canvas, area, points, clicked) {
    this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
  }

  drawUnderEyeBags(canvas, area, points, clicked) {
    if(area == 'left_eye_under' && this.getLeftEyeWidth() > this.UNDER_EYE_BAGS_WIDTH_CUTTOFF){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }

    if(area == 'right_eye_under' && this.getRightEyeWidth() > this.UNDER_EYE_BAGS_WIDTH_CUTTOFF){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }
  }

  drawNose(canvas, area, points, clicked) {
    this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
  }

  drawCheeks(canvas, area, points, clicked) {
    if(area == 'left_cheek' && this.getLeftCheekWidth() > this.CHEEK_WIDTH_CUTOFF){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }

    if(area == 'right_cheek' && this.getRightCheekWidth() > this.CHEEK_WIDTH_CUTOFF){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }
  }
  
  drawChin(canvas, area, points, clicked) {
    this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
  }

  drawMouthWrinkles(canvas, area, points, clicked) {
    if(area == 'left_lip_corner'){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }
    if(area == 'right_lip_corner'){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }
  }

  drawEyeWrinkles(canvas, area, points, clicked) {
    if(area == 'left_eye_corner' && this.getLeftCrowFeetWidth() > this.EYE_WRINKLE_MIN_WIDTH){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }

    if(area == 'right_eye_corner' && this.getRightCrowFeetWidth() > this.EYE_WRINKLE_MIN_WIDTH){
      this.drawEllipseOnCanvas(canvas, points, this.getAngleToFaceRightInRadians(), clicked)
    }
  }

	drawDetections(canvas){
		this.scaleCanvas(canvas)
		faceapi.draw.drawDetections(canvas, this.detection);
	}

	drawLandmarks(canvas){
		this.scaleCanvas(canvas)
		faceapi.draw.drawFaceLandmarks(canvas, this.faceLandmarks);
	}

	drawPolygonOnCanvas(canvas, points){
		this.scaleCanvas(canvas)

		var ctx = canvas.getContext("2d");
		for (let i = 0; i < points.length-1; i++) {
			ctx.beginPath();
			ctx.moveTo(points[i]._x, points[i]._y);
			ctx.lineTo(points[i+1]._x, points[i+1]._y);
			ctx.stroke();
		}

		// Final closing the polygon
		ctx.beginPath();
		ctx.moveTo(points[points.length-1]._x, points[points.length-1]._y);
		ctx.lineTo(points[0]._x, points[0]._y);
		ctx.stroke();
	}

	drawRectangleOnCanvas(canvas, rectanglePoints){
		this.scaleCanvas(canvas)

		var ctx = canvas.getContext("2d");
		ctx.beginPath();
		// ctx.rect(x, y, width, height);
		ctx.rect(rectanglePoints[0]._x, rectanglePoints[0]._y, rectanglePoints[1]._x - rectanglePoints[0]._x, rectanglePoints[1]._y - rectanglePoints[0]._y);
		ctx.stroke();
	}

	drawEllipseOnCanvas(canvas, rectanglePoints, tiltInRadians=0, clicked){
    this.scaleCanvas(canvas)

    let p1 = rectanglePoints[0]
    let p2 = rectanglePoints[1]
    let p3 = rectanglePoints[2]
    let p4 = rectanglePoints[3]

    let d1 = this.getDistanceBetweenPoints(p1, p2)/2
    let d2 = this.getDistanceBetweenPoints(p1, p4)/2
    let m = this.getMidpointBetweenPoints(p1, p3)

    var ctx = canvas.getContext("2d");
    ctx.beginPath();
    // ellipse(x, y, radiusX, radiusY, rotation, startAngle, endAngle)
    ctx.ellipse(m._x, m._y, d2, d1, tiltInRadians, 0, Math.PI*2);

    if(clicked){
      ctx.strokeStyle = this.STROKE_HIGHLIGHT_COLOR;
    } else {
      ctx.strokeStyle = this.STROKE_COLOR;
    }

    ctx.fillStyle = this.FILL_COLOR;
    ctx.fill();
    ctx.stroke();
  }
}

function selfieAreaClicked(area, message, x, y){
  document.getElementById("tangent-popup-msg-condition").innerHTML = message;
  if(area!=null){
     Object.assign(elPopupCondtion.style, {
        left: (x-30)+'px',
        top: (y+45)+'px',
        display: 'block',
    });
  }
  else{
    Object.assign(elPopupCondtion.style, {
        display: `none`,
    });
  }
}

//TO CLOSE POPUP IF OPEN ALREADY
document.body.addEventListener("click", function (evt) {
    if(evt.target.id != "selfie_canvas") {
      canvas.dispatchEvent(new MouseEvent("click", {
        clientX: 0,
        clientY: 0
      }));
    }
});

const canvas = document.getElementById('selfie_canvas');
let selfie = new TangentSelfie('selfie_img');

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();

      document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth'
      });
  });
});
